import React from 'react';
import useReportQueryParams from '../../hooks/use-report-query-params';
import KeyboardingOrganizationReport from './Organization';
import KeyboardingClassroomReport from './Classroom';
import KeyboardingStudentReport from './Student';
import ReportHeader from '../common/ReportHeader';
import { ReportEntityType } from '../../types';

const ENTITY_MAP: { [key in ReportEntityType]?: any } = {
  [ReportEntityType.DISTRICT]: KeyboardingOrganizationReport,
  [ReportEntityType.SCHOOL]: KeyboardingOrganizationReport,
  [ReportEntityType.USER_GROUP]: KeyboardingOrganizationReport,
  [ReportEntityType.USER]: KeyboardingOrganizationReport,
  [ReportEntityType.CLASSROOM]: KeyboardingClassroomReport,
  [ReportEntityType.STUDENT]: KeyboardingStudentReport
};

const KeyboardingReport: React.FC = () => {
  const [{ entityType, entityId }] = useReportQueryParams();
  const EntityReport = ENTITY_MAP[entityType];

  if (!entityId) return null;

  if (!EntityReport) return null;

  return (
    <>
      <ReportHeader />
      <EntityReport />
    </>
  );
};

export default KeyboardingReport;
